// @flow
import { getSetting } from "../../../constants/Settings";

import type { IConstraintModel } from "../../types";

/**
 */
export default class ConstraintModel implements IConstraintModel {
  _id: string;
  _validateMethod: ?(value: any) => boolean;
  _defaultMessage: ?string;
  _parameters: ?Object;
  _useClientsideValidation: boolean;

  /**
   */
  constructor(
    id: string,
    validateMethod: ?Function,
    defaultMessage: ?string,
    parameters: ?Object,
    useClientsideValidation: boolean = getSetting("USE_CLIENTSIDE_VALIDATION"),
  ) {
    this._id = id;
    this._validateMethod = validateMethod;
    this._defaultMessage = defaultMessage;
    this._parameters = parameters;
    this._useClientsideValidation = useClientsideValidation;
  }

  /**
   * Retreive type of constraint
   */
  get id(): string {
    return this._id;
  }

  /**
   */
  get defaultMessage(): string {
    return this._defaultMessage || "Missing default message";
  }

  /**
   * Returns available data for constraint
   */
  get parameters(): ?Object {
    return this._parameters;
  }

  /**
   * Inidicates if validation message is present
   */
  hasValidation(): boolean {
    return this._validateMethod != null;
  }

  /**
   * Validate constraint with value
   */
  validate(value: any): boolean {
    const validateMethod = this._validateMethod;

    if (this._useClientsideValidation && validateMethod) {
      return validateMethod(value);
    }

    return true;
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return this._id === "mandatory" || this._id === "Constraint.Mandatory";
  }
}
